import {useTranslation} from 'react-i18next'
import {Skeleton} from '@/components/ui/skeleton'
import {Hint} from '@/components/ui/hint'

export function PreparandoCola({tarjetas, personas}: {tarjetas: number; personas: number}) {
  const {t} = useTranslation()
  return (
    <section className="surface space-y-3 px-5 py-6" data-testid="cola-preparando">
      <p className="font-heading text-base text-foreground">{t('admin.bateria.cola.preparando.titulo')}</p>
      <p className="font-mono text-[11px] tracking-wider text-muted-foreground uppercase">
        {t('admin.bateria.cola.preparando.tarjetas', {count: tarjetas})}
        {' · '}
        {t('admin.bateria.cola.preparando.personas', {count: personas})}
      </p>
      <Skeleton className="h-48 w-full" />
      <Hint>{t('admin.bateria.cola.preparando.ayuda')}</Hint>
    </section>
  )
}

/** Una posición cuyo tramo no llegó: la pantalla espera en vez de rechazar un número que ella misma citó. */
export function TarjetaEnCamino({numero}: {numero: number}) {
  const {t} = useTranslation()
  return (
    <section className="surface space-y-3 px-5 py-6" data-testid="cola-tarjeta-en-camino">
      <p className="font-mono text-[11px] tracking-wider text-muted-foreground uppercase">
        {t('admin.bateria.cola.enCamino.titulo', {numero})}
      </p>
      <Skeleton className="h-40 w-full" />
      <Hint>{t('admin.bateria.cola.enCamino.cuerpo')}</Hint>
    </section>
  )
}
